import Cookies from 'js-cookie'

export function clearAllCookies() {
  Object.keys(Cookies.get()).forEach(function (cookie) {
    if (cookie !== 'storedLanguage') Cookies.remove(cookie)
  })
}
